module.exports = __webpack_public_path__ + "img/enableOpenProjectInfo_01.675aaef5.png";